const HOVER_CARD_ERRORS = {
  context: "HoverCard component was not found in the tree",
  children: "HoverCard.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
};

export { HOVER_CARD_ERRORS };
//# sourceMappingURL=HoverCard.errors.js.map
